import { WSProgressBar } from "@wingspanhq/fe-component-library";
import { Batch } from "@wingspanhq/wingspan-api-sdk";
import { queriesBatches } from "@query";
import { WSQueryCache } from "@ws-react-query";
import { useEffect } from "react";

import { IMPORT_PROGRESS_REFETCH_INTERVAL } from "../../constants";
import { useFlatfileUploadJobStatus } from "../../hooks/useFlatfileUploadJobStatus";

/**
 * Progress of the Flatfile job that creates the batch items, while the
 * spreadsheet is being uploaded into the batch.
 */
export const ImportBatchUploadProgress: React.FC<{ batch: Batch }> = ({
  batch
}) => {
  const batchId = batch.id as string;

  // Keeps the row count on the details page moving while the upload runs.
  queriesBatches.getBatchSummary.useQuery(
    { batchId },
    { refetchInterval: IMPORT_PROGRESS_REFETCH_INTERVAL }
  );

  const { progress } = useFlatfileUploadJobStatus(batch);

  useEffect(() => {
    return () => {
      // The upload is done, so pick up the rows it created.
      WSQueryCache.invalidateQueries(queriesBatches.getBatch.queryKeyBase);
      WSQueryCache.invalidateQueries(
        queriesBatches.getBatchSummary.queryKeyBase
      );
    };
  }, [batchId]);

  return <WSProgressBar percent={progress} text={null} />;
};
